import { useQuery } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'

/** Carga de una ruta: día y número de clientes agendados esta semana. */
export interface CargaRuta {
  ruta: 'r1' | 'r2' | 'r3' | 'r4' | 'r5'
  dia: string
  carga: number
}

/** Carga por ruta de la semana activa (R7 · B.7), para el panel admin. */
export function useCargaRutas() {
  const api = useApi()
  return useQuery<CargaRuta[], ErrorApi>({
    queryKey: ['rutas', 'carga'],
    queryFn: ({ signal }) => api.pedir<CargaRuta[]>('/api/rutas/carga', { senal: signal }),
  })
}
